import type { TCaptionMap } from '@shared/backendFrontend/captionHelpersFe';
import type { TOptionModeLocked } from '@shared/components';

import type { OutRefBookmarkKind } from '../tiptap/nodes/caption/constants';
// `import type`: version.types re-enters the documents barrel, and pulling that in at runtime from a
// file `constants.ts` imports is how a circular init leaves an enum undefined for its first reader.
import type { TDraft, TVersion } from './version.types';

export enum EHeadingsSelectionMode {
  ALL = 'ALL',
  SPECIFIC = 'SPECIFIC',
}

export enum EHeadingSelectionLabel {
  REFERENCE = 'reference',
  ASSOCIATE = 'associate',
  ANALYZE = 'analyze',
}

export enum EHeadingSelectionPurpose {
  BLOCK = 'BLOCK',
  REFERENCE = 'REFERENCE',
  ASSOCIATION = 'ASSOCIATION',
}

export interface TSelectHeadingDialogState {
  isOpen: boolean;
  documentId: string;
  version: TVersion | TDraft;
  /**
   * `excludeVersionIdParam` determines whether we want to open a document
   * of a specific version or the latest version of the document
   * when clicking on a heading in the tree.
   *
   * Defaults to `undefined` (falsy)
   * which means that the latest version of the document is opened.
   *
   * Optional, because is e.g. not needed in `association` feautre.
   */
  excludeVersionIdParam?: boolean;
  mode: EHeadingsSelectionMode;
  modeLocked: TOptionModeLocked;
  initialSelectedIds?: string[];
  initialAutoDisabledIds?: string[];
  onSelect: (
    selectedMode: EHeadingsSelectionMode,
    newSelectedIds: ReadonlySet<string>,
    newAutoDisabledIds: ReadonlySet<string>
  ) => Promise<void>;
  /**
   * "Auto select children" is a feature that automatically selects all children of a heading when the heading is selected.
   * Disabled by default (falsy) because currently it's only used in "pre-change impact analysis" feature.
   */
  enableAutoChildrenSelection?: boolean;
}

export type TLockedState = {
  isOpen: boolean;
  lockedUserId: null | string;
  message?: string;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
};

export interface TSelectCaptionDialogState {
  isOpen: boolean;
  captionKind: OutRefBookmarkKind;
  captionsMap: TCaptionMap;
  onSelect: (captionId: string) => void;
}

export type TMathematicsDialogState = {
  isOpen: boolean;
};
